import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import { NavLink } from 'react-router-dom';
import logo from '../../logo.png';

function Navbar() {
  const linkStyle = {
    color: 'inherit',
    textDecoration: 'none',
    marginLeft: '1rem',
    display: 'flex',
    alignItems: 'center',
    transition: 'color 0.3s, border-bottom 0.3s',
  };

  const activeStyle = {
    fontWeight: 'bold',
    borderBottom: '2px solid white',
  };

  const hoverStyle = {
    color: '#f0f0f0',
    borderBottom: '2px solid #f0f0f0',
  };

  return (
    <AppBar position="static" sx={{ bgcolor: '#222', boxShadow: 'none' }}>
      <Toolbar>
        <NavLink
          to="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            color: 'inherit',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Neehaw
          </Typography>
          <img
            src={logo}
            alt="Neehaw Logo"
            style={{ width: 30, marginRight: 8 }}
          />
        </NavLink>
        <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto' }}>
          {['Home', 'Projects', 'About'].map((text) => (
            <NavLink
              key={text}
              to={text === 'Home' ? '/' : `/${text.toLowerCase()}`}
              style={linkStyle}
              className={({ isActive }) => (isActive ? activeStyle : undefined)} // For v6, `activeStyle` replaced by `className`
            >
              <Box
                component="span"
                sx={{
                  '&:hover': hoverStyle,
                }}
              >
                {text}
              </Box>
            </NavLink>
          ))}
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
